// extracted by mini-css-extract-plugin
export default {"heading":"UserLogin_heading__nJX+f","subheading":"UserLogin_subheading__pRnFQ","cursor":"UserLogin_cursor__IQr1j","loginButton":"UserLogin_loginButton__TK+xz"};